function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8789 2.32611C17.4435 1.90569 16.9265 1.57219 16.3575 1.34465C15.7886 1.11711 15.1787 1 14.5628 1C13.9469 1 13.337 1.11711 12.768 1.34465C12.199 1.57219 11.6821 1.90569 11.2467 2.32611L10.343 3.19821L9.43942 2.32611C8.55993 1.4773 7.36709 1.00044 6.1233 1.00044C4.87951 1.00044 3.68667 1.4773 2.80718 2.32611C1.92769 3.17492 1.43359 4.32616 1.43359 5.52656C1.43359 6.72696 1.92769 7.87819 2.80718 8.727L3.7108 9.5991L10.343 16L16.9753 9.5991L17.8789 8.727C18.3145 8.30679 18.6601 7.80785 18.8958 7.25871C19.1316 6.70957 19.253 6.12097 19.253 5.52656C19.253 4.93214 19.1316 4.34355 18.8958 3.7944C18.6601 3.24526 18.3145 2.74633 17.8789 2.32611V2.32611Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bdb32f66.svg";
export { ForwardRef as ReactComponent };